import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div>
      
<footer className="text-start text-lg-start bg-body-tertiary">
  
  <section className="d-flex footer justify-content-center justify-content-lg-between p-4 border-bottom">
    
    <div className="me-5 d-none d-lg-block">
      <span>Get connected with us on social networks:</span>
    </div>
    
    <div>
      <a href="https://www.facebook.com/farooq.graphics.designing.official/" className="me-4 text-reset">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href="https://twitter.com/TechnicMentors" className="me-4 text-reset">
        <i className="fab fa-twitter"></i>
      </a>
      <a href="https://www.pinterest.com/ap900244/" className="me-4 text-reset">
        <i className="fab fa-pinterest"></i>
      </a>
      <a href="/#" className="me-4 text-reset">
        <i className="fab fa-instagram"></i>
      </a>
      <a href="/#" className="me-4 text-reset">
        <i className="fab fa-linkedin"></i>
      </a>
      <a href="/#" className="me-4 text-reset">
        <i className="fab fa-behance"></i>
      </a>
    </div>

  </section>
  
  <section className="footer-columns p-2">
    <div className="container text-start text-md-start mt-5">
      
      <div className="row mt-2">
        
        <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
         
          <h6 className="text-uppercase fw-bold mb-4">
            <i className="fas fa-gem me-3"></i>Farooq Graphics
          </h6>
          <p>
          We bleed C.M.Y.K., we breathe Helvetica, we love Whitespace. Yes, we are designers!! We transcend traditional graphic design boundaries. Our approach is rooted in innovation, empowering your ideas to reach new heights.
          </p>
        </div>
     
        <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
         
          <h6 className="text-uppercase fw-bold mb-4">
            Services
          </h6>
          <p>
            <Link to="/our-services" className="text-reset">Design Services</Link>
          </p>
          <p>
            <Link to="/our-services" className="text-reset">Print & Packaging</Link>
          </p>
          <p>
            <Link to="/our-services" className="text-reset">Social Media Graphics</Link>
          </p>
          <p>
            <Link to="/our-services" className="text-reset">Illustration Services</Link>
          </p>
          <p>
            <Link to="/our-services" className="text-reset">Motion Graphics & Animations</Link>
          </p>
          <p>
            <Link to="/our-services" className="text-reset">Brand Identity</Link>
          </p>
        </div>
       
        <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
          
          <h6 className="text-uppercase fw-bold mb-4">
            projects
          </h6>
          <p>
            <Link to="/our-work" className="text-reset">Logo Designs</Link>
          </p>
          <p>
            <Link to="/our-work" className="text-reset">Give Aways</Link>
          </p>
          <p>
            <Link to="/our-work" className="text-reset">Bags Design</Link>
          </p>
          <p>
            <Link to="/our-work" className="text-reset">Suit Box Design</Link>
          </p>
          <p>
            <Link to="/our-work" className="text-reset">Restaurant & Cafe Menus</Link>
          </p>
        </div>
        
        <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
         
          <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
          <p><i className="fas fa-home me-3"></i> 6 Ahmad Pura, Nomania Road, Gujranwala</p>
          <p>
            <i className="fas fa-envelope me-3"></i>
            farooqgraphics@gmail.com
          </p>
          <i className="fab fa-whatsapp me-3"></i> <a href="https://web.whatsapp.com/send?phone=+923225628100" style={{color: '#fff', fontFamily: "poppins"}}>0322 56 28 100</a><br /><br />
          <p><i className="fas fa-print me-3"></i> + 01 234 567 89</p>
        </div>
        
      </div>
      
    </div>
  </section>
  <hr style={{height: '2px', color: '#fff'}}  />
  
  <div className="text-center justify-content-center align-items-center" style={{paddingTop: '5px', paddingBottom: '6'}}>
    © Copyright: <strong> Farooq Graphcis </strong><br />
    Developed With Love By <a className="text-reset fw-bold" href="https://technicmentors.com/" style={{marginBottom: '6'}}>Technic Mentors</a>
  </div>
  
</footer>

    </div>
  )
}

export default Footer
